import { Image } from 'palette/Image';
import { BEMBlock } from '@helpers/classnames';
import '../styles/HeaderBanner.scss';

export function HeaderBanner({
    imageSrc, link, text
}) {
    const [block, BEMElement] = BEMBlock('header-banner');
    return (
        <figure className={block}>
            <a href={link}>
                <Image
                    alt={text}
                    className={BEMElement('image')}
                    loading="lazy"
                    src={imageSrc}
                />
                <figcaption className={BEMElement('text')}>{text}</figcaption>
            </a>
        </figure>
    );
}
